var render = function render(){var _vm=this,_c=_vm._self._c;return _c('market-card',{staticClass:"market-hours",attrs:{"title":_vm.$t('pages.login.user.card_opening_hours.title')}},[_c('market-opening-hours-list',{attrs:{"market":_vm.market}}),(_vm.market.openingHoursExtraInfo)?_c('p',{staticClass:"small text-muted pre-wrap mt-2 mb-0"},[_vm._v(" "+_vm._s(_vm.market.openingHoursExtraInfo)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }